<template>
    <van-form ref="basicInformation" readonly>

        <van-cell class="field-title">出口商(Exporter)</van-cell>
        <van-field v-model="originCertificate.exporter"></van-field>

        <van-cell class="field-title">收货方/进口商(Consignee)</van-cell>
        <van-field v-model="originCertificate.importer" type="textarea" rows="1" autosize></van-field>

        <van-cell  v-if="checkProducer(region.value)||'REGION_CODE_14' === region.value" class="field-title">生产商(Producer)</van-cell>
        <van-field  v-if="checkProducer(region.value)||'REGION_CODE_14' === region.value" v-model="originCertificate.producer" type="textarea" rows="1" autosize></van-field>

        <van-cell class="field-title">运输路线(Means of transport and route)</van-cell>
        <van-field v-model="originCertificate.transportLine" type="textarea" rows="1" autosize></van-field>

        <van-cell class="field-title">申请地点(Place of application)</van-cell>
        <van-field v-model="originCertificate.applyAddr"></van-field>

        <van-cell class="field-title">申请日期(Date of application)</van-cell>
        <van-field v-model="originCertificate.applyTime"></van-field>

        <van-cell class="field-title">签署地点(Place of issuance)</van-cell>
        <van-field v-model="originCertificate.signAddr"></van-field>

        <van-cell class="field-title">签署日期(Date of issuance)</van-cell>
        <van-field v-model="originCertificate.signTime"></van-field>

        <van-cell class="field-title">货物的单位名称</van-cell>
        <van-field v-model="originCertificate.weightMarkup"></van-field>

        <van-cell v-if="'REGION_CODE_01' != region.value" class="field-title">备注(Remarks)(BOX 8)</van-cell>
        <van-field v-if="'REGION_CODE_01' != region.value" v-model="originCertificate.remark" type="textarea" rows="1" autosize></van-field>

    </van-form>
</template>

<script>

    import originCertificateRegion from "../../../origin-certificate/service/origin-certificate-region";

    export default {
        name: "PrefBasicInformationView",
        props: {
            region: Object,
            viewedOriginCertificate: Object,
        },
        data() {
            return {
                originCertificate: Object.assign({}, this.viewedOriginCertificate),
            }
        },
        created() {
            if (this.viewedOriginCertificate.originCertificateTransport) {
                this.originCertificate.transportLine = this.viewedOriginCertificate.originCertificateTransport.transportLine;
            }
        },
      methods: {
        checkProducer(value) {
          return originCertificateRegion.checkProducer(value);
        },
      }
    }
</script>

<style lang="scss" scoped>
    ::v-deep {
        .field-title {
            padding: 13px 16px 0 24px !important;

            &:after {
                display: none;
            }

            .van-cell__value {
                color: #969799;
            }
        }
        .van-cell.van-field {
            padding: 13px 16px 0 24px !important;
        }
    }
</style>